import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export const getOnboardingContext = () =>
  getCommonsNorthboundAPIs().v1.store.state.onboarding.sessionContext
    .onboardingContext
